import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { LinkSyncPipe } from '@ecm/router';

import { CarrouselItemViewModel } from '../../business/model/carrousel-item.view-model';
import { CarrouselStoreService } from '../../store/carrousel-store.service';

@Component({
    selector: 'ecm-carrousel-item-mobile',
    templateUrl: 'carrousel-item-mobile.component.html',
    styleUrls: ['carrousel-item-mobile.component.css'],
    standalone: true,
    imports: [CommonModule, LinkSyncPipe, TranslateModule],
})
export class CarrouselItemMobileComponent implements OnInit {
    @Input() public carrouselItem: CarrouselItemViewModel;
    @Input() public selectedLink: string;
    public carrouselDetailsTranslate: any;

    public constructor(
        private readonly translate: TranslateService,
        protected carrouselStore: CarrouselStoreService,
    ) {}

    public ngOnInit() {
        this.carrouselDetailsTranslate = this.translate.instant('details');
    }

    public selectAvatar(item: CarrouselItemViewModel) {
        if (item.type !== 'member') return;
        const avatarButton = {
            ...item.button,
            link: {
                references: [
                    {
                        linkWeb: { inApp: this.carrouselDetailsTranslate.profile.url + item.id },
                    },
                ],
            },
            navigationExtras: { queryParams: {} },
        };
        this.carrouselStore.openLink(avatarButton);
    }
}
